var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupsIncluded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6469 6.68441C13.3474 6.68441 12.2939 5.62402 12.2939 4.31599C12.2939 3.00795 13.3474 1.94757 14.6469 1.94757C15.9464 1.94757 16.9998 3.00795 16.9998 4.31599C16.9998 5.62402 15.9464 6.68441 14.6469 6.68441Z",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeMiterlimit: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88235 4.78947C1.84276 4.78947 1 3.94115 1 2.89474C1 1.8483 1.84276 1 2.88235 1C3.92193 1 4.76471 1.8483 4.76471 2.89474C4.76471 3.94115 3.92193 4.78947 2.88235 4.78947Z",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeMiterlimit: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4707 17.5791L12.2942 15.2106V12.3685C12.2942 10.7267 13.2354 9.52643 14.6472 9.52643C16.0589 9.52643 17.0001 10.7267 17.0001 12.3685V14.6598V19.0001",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52941 14.737L5.70588 12.3686V10.4738C5.70588 8.83198 4.76471 7.63171 3.35294 7.63171C1.94118 7.63171 1 8.83198 1 10.4738V11.8178V19.0001",
    stroke: "#868FAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsIncluded);
export default __webpack_public_path__ + "static/media/groupsIncluded.f1a257ed4b984c9b03df099ea8ea5564.svg";
export { ForwardRef as ReactComponent };